/**
 * 数据格式化工具类
 * <tian.xu96@qq.com>
 * */

import moment from 'moment'

let FormatUtil = {
  timestamp2date: (timestamp, format = 'YYYY-MM-DD HH:mm:ss') => {
    return moment.unix(timestamp).format(format)
  },
}

export default FormatUtil